export function buildAttributesQueryString(attributes) {
    let attributeString = attributes.map(x => `${x.name};${x.value}`).reduce((prev, current) => prev + '|' + current, '');
    return attributeString;
}

export function buildQueryString(searchString, attributes, productAttributes, articlePaginationViewModel, productPaginationViewModel, view) {
    let queryParams = {};
    if (searchString)
        queryParams.searchString = searchString;
    const productAttributesQueryString = productAttributes && productAttributes.length > 0 ? buildAttributesQueryString(productAttributes) : null;
    const articleAttributesQueryString = attributes && attributes.length > 0 ? buildAttributesQueryString(attributes) : null;    
    if (productAttributesQueryString && productAttributesQueryString.length > 0)
        queryParams.c = productAttributesQueryString;
    if (articleAttributesQueryString && articleAttributesQueryString.length > 0)
        queryParams.ac = articleAttributesQueryString;    
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentPageIndex)
        queryParams.articlePageIndex = articlePaginationViewModel.CurrentPageIndex;
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentItemsPerPage)
        queryParams.articlePageSize = articlePaginationViewModel.CurrentItemsPerPage;
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentSortBy)
        queryParams.sa = articlePaginationViewModel.CurrentSortBy;
    if (productPaginationViewModel && productPaginationViewModel.CurrentSortBy)
        queryParams.sp = productPaginationViewModel.CurrentSortBy;
    if (articlePaginationViewModel && articlePaginationViewModel.CurrentItemsPerPage)
        queryParams.aq = productPaginationViewModel.CurrentItemsPerPage;
    if (productPaginationViewModel && productPaginationViewModel.CurrentItemsPerPage)
        queryParams.pq = productPaginationViewModel.CurrentItemsPerPage;
    if (view)
        queryParams.view = view;
    return serialize(queryParams);
}

export function serialize(obj) {
    return '?' + Object.keys(obj).reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a; }, []).join('&');
}
